import { render, staticRenderFns } from "./DvTab.vue?vue&type=template&id=18c46888&scoped=true&lang=pug"
import script from "./DvTab.vue?vue&type=script&lang=js"
export * from "./DvTab.vue?vue&type=script&lang=js"
import style0 from "./DvTab.vue?vue&type=style&index=0&id=18c46888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c46888",
  null
  
)

export default component.exports